export default "__VITE_ASSET__BjOd2D0b__"